import { Form, FormInstance, Row, Select } from "antd";
import { ReactNode, useCallback, useEffect, useMemo, useState } from "react";
import { useFetchEmailReciever } from "./hooks/useFetchEmailReciever";
import _ from "lodash";
import { useGetTooltip } from "./hooks/useGetTooltip";
import { SelectOption } from "./SelectOption";
import { useRules } from "./hooks/useRules";
import { useTagRender } from "./hooks/useTagRender";
import { useTagLabel } from "./hooks/useTagLabel";

type SendToFormItemProps = {
  form: FormInstance;
  initalData: any;
  optionsData: any;
  setOptionsData: React.Dispatch<React.SetStateAction<any>>;
  clearError: () => void;
  isEmailView?: boolean;
  status?: number;
};

export const SendToFormItem = ({
  form,
  initalData,
  optionsData,
  setOptionsData,
  clearError,
  isEmailView,
  status
}: SendToFormItemProps) => {
  const { rules } = useRules(optionsData, isEmailView, status);

  const [sendToValues, setSendToValues] = useState<any[] | undefined>(undefined);

  const { isLoading, search, testEmail } = useFetchEmailReciever(setOptionsData, setSendToValues);

  useEffect(() => {
    setOptionsData(initalData);
  }, [initalData, setOptionsData]);

  useEffect(() => {
    try {
      (isEmailView || optionsData.length > 2) && form.validateFields();
    } catch {}
  }, [form, optionsData, isEmailView]);

  useEffect(() => {
    sendToValues && form.setFieldsValue({ sendTo: sendToValues });
  }, [form, sendToValues]);

  const options: ReactNode = useMemo(() => {
    console.log("optionsData: ", optionsData);
    const values = optionsData.map((item: any) => {
      const name: string = item.isEmail ? `<${item.name}>` : item.name;

      return (
        <Select.Option key={item.value} className="send-to-select-item">
          <SelectOption name={name} item={item} showEmail isEmailView={isEmailView} />
        </Select.Option>
      );
    });

    return values;
  }, [optionsData, isEmailView]);

  const { getTooltip } = useGetTooltip();

  const { getTagLabel } = useTagLabel(isEmailView);

  const getIsError = useCallback(
    (item: any): boolean => {
      return (!item || !item.email) && !isLoading;
    },
    [isLoading]
  );

  const { tagRender } = useTagRender(optionsData, getTagLabel, getTooltip, getIsError);

  const onSelect = useCallback(
    (value: string, option: any) => {
      if (Object.keys(option).length === 0) {
        const val = +value;

        val && !_.isNaN(val) ? search(val) : testEmail(value);
      } else {
        setSendToValues((prev) => [...(prev ?? []), value]);
      }
    },
    [search, testEmail]
  );

  const onDeselect = useCallback((value: string) => {
    setSendToValues((prev) => (prev ? prev.filter((item) => item !== value) : prev));
  }, []);

  const dropdownRender = useCallback((originNode: any) => {
    return (
      <Row className="d-block">
        <p className="my-1 mx-3 text-sm title">Select from the list or input Customer#/Email Address and click Enter</p>
        {originNode}
      </Row>
    );
  }, []);

  return (
    <Form.Item label="Send To" name="sendTo" rules={rules}>
      <Select
        mode="tags"
        optionFilterProp="children"
        className="send-to-select"
        tagRender={tagRender}
        onSelect={onSelect}
        onDeselect={onDeselect}
        loading={isLoading}
        dropdownRender={dropdownRender}
        onChange={clearError}
      >
        {options}
      </Select>
    </Form.Item>
  );
};
